import { combineReducers } from "redux";
import { getYear } from "../../utils/tool";
export const types = {
  SET_SHOW_PAY: "USER_PAY/SET_SHOW_PAY",
  SET_PAY_MARK_ARRAY: "USER_PAY/SET_PAY_MARK_ARRAY",
  SET_PAY_USE_YEAR: "USER_PAY/SET_PAY_USE_YEAR",
  SET_PAY_PRICE: "USER_PAY/SET_PAY_PRICE",
};

const initialState = {
  uiState: {
    showPay: false,
    useYear: getYear(),
    price: "365.00",
    markArray: [0, 0, 0],
  },
};

export const actions = {
  setShowPay: (showPay) => {
    return {
      type: types.SET_SHOW_PAY,
      showPay,
    };
  },
  setPayMarkArray: (markArray) => {
    return {
      type: types.SET_PAY_MARK_ARRAY,
      markArray,
    };
  },
  setPayUseYear: (useYear) => {
    return {
      type: types.SET_PAY_USE_YEAR,
      useYear,
    };
  },
  setPayPrice: (price) => {
    return {
      type: types.SET_PAY_PRICE,
      price,
    };
  },
};
//支付框的ui样式数据
const uiStateData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_SHOW_PAY:
      return { ...state, showPay: action.showPay };
    case types.SET_PAY_MARK_ARRAY:
      return { ...state, markArray: action.markArray };
    case types.SET_PAY_USE_YEAR:
      return { ...state, useYear: action.useYear };
    case types.SET_PAY_PRICE:
      return { ...state, price: action.price };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  uiStateData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/pay.js